import { useContext } from 'react';
import { FormContext } from '../FormContext';
export function useForm() {
    const { store } = useContext(FormContext);
    //useStore(store); // useStore triggers re-rendering on state changes
    const handleBlur = (path) => {
        const field = store.getField(path);
        store.changeFieldMeta(path, { touched: true });
        if (field.validateOnBlur)
            store.validateField(path);
    };
    const handleFocus = (path) => { };
    const handleSubmit = (evt) => {
        evt.preventDefault();
        store.submit();
    };
    return Object.assign(Object.assign({ handleBlur,
        handleSubmit,
        handleFocus }, store), { store });
}
//# sourceMappingURL=useForm.js.map